(function () {
    "use strict";

    angular
        .module("app")
        .directive("briefPatterns", briefPatterns);

    function briefPatterns(BriefService, PatternService) {
        return {
            restrict: "E",
            link: function (scope) {
                scope.loadItem = { PatternSeasonalId: null };
                scope.loadData = function (id) {
                    if (id !== undefined) {
                        if (scope.$root.pId) {
                            PatternService.getPatternSeasonalDetails(scope.$root.pId).then(function (response) {
                                scope.pattern = response;
                                PatternService.getPatternDetails(scope.pattern.PatternId).then(function (response) {
                                    scope.patterns = []
                                    scope.patterns.push(response);
                                    scope.loadItem.PatternSeasonalId = scope.pattern.PatternSeasonalId;
                                    scope.$root.pName = response.Name;
                                })
                            });
                        } else {
                            console.log('loading brief patterns...');
                            //Get Brief Patterns
                            BriefService.getBriefPatterns(id).then(function (data) {
                                scope.patterns = data;
                                console.log(scope.patterns);
                            });
                        }
                    }
                }

                scope.loadData(scope.briefId);

                scope.$watch("briefId", function (newValue, oldValue) {
                    if (newValue !== oldValue)
                        scope.loadData(newValue);
                });

                scope.$watch("updateDirectives", function (newValue) {
                    if (typeof newValue == 'undefined')
                        return;
                    scope.loadData(newValue);
                });
            },
            scope: { briefId: "=", updateDirectives: "=" },
            templateUrl: templateUrl("app/directives/linePlan/briefPatterns.directive.html")
        };
    }
})();